export enum ParkerOffenseFilterType {
  Parker = 0,
  Offense = 1,
  ParkingRangerEntry = 2
}
